import {useQuery} from "../../../features/common_funcs/query_hook/useQuery";
import {useEffect, useRef, useState} from "react";
import {useUser} from "../../../features/user/useUser";
import {useQueryParams} from "../../../features/common_funcs/query_hook/useQueryParams";
import {User} from "../../../features/user/models/model";

const useUserCardWindow = () => {
    const { showUserWithId } = useQueryParams();
    const { updateQueryParameter } = useQuery();
    const userIdPrev = useRef<string|undefined>();
    const { getOneUser } = useUser();
    const [isUserLoading, setIsUserLoading] = useState<boolean>(false);
    const [openedUser, setOpenedUser] = useState<User | null>(null);

    const handleClose = () => {
        updateQueryParameter('showUserWithId', null);
    }

    useEffect(() => {
        if (showUserWithId !== userIdPrev.current) {
            userIdPrev.current = showUserWithId;
            if (showUserWithId && !isNaN(Number(showUserWithId))) {
                const userId: number = Number(showUserWithId);
                getOneUser(userId, setIsUserLoading, (loadedUser) => {
                    setOpenedUser(loadedUser);
                });
            } else {
                setOpenedUser(null);
            }
        }
    }, [getOneUser, showUserWithId]);

    return { openedUser, isUserLoading, handleClose, open: showUserWithId !== undefined };
}

export default useUserCardWindow;